import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { HyperlinkComponentModule } from '@adaptiva/widgets/hyperlink';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { BlacklistPropertiesComponent } from './blacklist-properties.component';

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	ToggleSwitchComponent,
	AuthoringPropertyLabelComponentModule,
	HyperlinkComponentModule
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
	InheritPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS,
	],
	declarations: [BlacklistPropertiesComponent],
	exports: [BlacklistPropertiesComponent]
})
export class BlacklistPropertiesComponentModule {

}
